'use client';
const ZIndexElevations = {
    /**
     * Диапазон значений 100-200 предназначен для потенциального размещения
     * компонентов приложения друг относительно друга по оси z.
     *
     * Не используется для модальных окон и плавающих элементов.
     * */ app: 100,
    /**
     * Предназначено для модальных окон и их оверлеев.
     * */ modal: 200,
    /**
     * Базовый z-index для компонентов Popover, Hint и Tooltip.
     *
     * Dropdown-элементы ряда компонентов, таких как Select, MultiSelect и подобных,
     * также имеют данный z-index.
     * */ popover: 300,
    /**
     * Предназначено для потенциальных оверлеев, перекрывающих всё.
     * */ overlay: 400,
    /**
     * Обозначает крайний верхний z-index.
     * Категорически не рекомендуется использовать значения выше.
     * */ max: 9999
};

export { ZIndexElevations };
//# sourceMappingURL=domain.js.map
